import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon } from '@livable/saas-react-components';
import { Button, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { useStore } from 'src/stores';
export default function UnitCounter(_ref) {
  let _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$remove = _ref.remove,
    remove = _ref$remove === void 0 ? () => {} : _ref$remove,
    _ref$add = _ref.add,
    add = _ref$add === void 0 ? () => {} : _ref$add,
    changeCount = _ref.changeCount,
    withoutControllers = _ref.withoutControllers;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const store = useStore();
  const _useState = useState(value === 0 ? 1 : value),
    _useState2 = _slicedToArray(_useState, 2),
    counterValue = _useState2[0],
    setCounterValue = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    counterIsDisabled = _useState4[0],
    setCounterIsDisabled = _useState4[1];
  const applyNewCounterValue = () => {
    changeCount(counterValue, '0');
    setCounterIsDisabled(true);
  };
  useEffect(() => {
    setCounterValue(value === 0 ? 1 : value);
  }, [value]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.number_of_residential_units')), /*#__PURE__*/React.createElement("div", {
    className: classes.unitsCounter
  }, !withoutControllers && /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "large",
    disabled: value === 0,
    onClick: remove,
    'custom-attribute': '142-unit-counter'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "minus"
  })), /*#__PURE__*/React.createElement("div", {
    className: "\n            ".concat(classes.unitsCounterInput, "\n            ").concat(withoutControllers ? classes.unitsCounterInputWithoutControllers : null, "\n          ")
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "door"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "units-input",
    value: counterValue,
    label: t('general.units'),
    variant: "outlined",
    type: "number",
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^[1-9][0-9]*$|^$/.test(e.target.value)) return;
      if (value === +e.target.value || e.target.value.length === 0) {
        setCounterIsDisabled(true);
      } else {
        setCounterIsDisabled(false);
      }
      setCounterValue(e.target.value);
    }
  }))), !withoutControllers && /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "large",
    onClick: add,
    'custom-attribute': '143-unit-counter'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  })), withoutControllers && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: counterIsDisabled,
    onClick: applyNewCounterValue,
    'custom-attribute': '144-unit-counter'
  }, t('buttons.confirm'))));
}
UnitCounter.propTypes = {
  value: PropTypes.number,
  remove: PropTypes.func,
  add: PropTypes.func
};